const removeActiveElement = (activeElementIds: string[], elementIdToRemove: string): string[] => {
  const elementIndex = activeElementIds.findIndex(
    activeElementId => activeElementId === elementIdToRemove
  );
  return activeElementIds.splice(elementIndex, 1);
};

export default removeActiveElement;
